import * as React from 'react'
import { connect } from "react-redux";

import {
    State,
    Violation
} from "../../types";
import { sendViolationDetail} from "../../actions";
import { BlankSlate } from "./BlankSlate";
import { Loading } from "./Loading";
import Data from "./Data";
import "./violationsHistoryDetailsStyle.css";
import {setSelectedItemId, setViolationListType} from "../../utils";

interface IState {
    Selecteditemid: string
    showPopupImage: boolean,
}

type Props = {
    violation: Violation,
    hasError: boolean,
    isLoading: boolean,
    dispatch: Function
}

export const ViolationsHistoryDetails = connect((state: State, ownProps: any) => {
    const violationDetail = state.violationHistory.violationDetail;
    const { violation, hasError, isLoading } = violationDetail;

    return {
        violation,
        hasError,
        isLoading
    }
})
(class ViolationsHistory extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props)
        this.state = {
            Selecteditemid: '',
            showPopupImage: false,
        }
        this.imagePopupToggle=this.imagePopupToggle.bind(this)
    }

    componentDidMount() {
        const {dispatch} = this.props;
        // dispatch(fetchViolationsHistory());
        if (window.history && window.history.state && window.history.state.state !== undefined) {
            setViolationListType('recent');
            setSelectedItemId(window.history.state.state.targetkey);
            dispatch(sendViolationDetail(window.history.state.state.targetkey, 'recent'));
        } else {
            setViolationListType('history');
            dispatch(sendViolationDetail('', ''));
        }

        

    }
    imagePopupToggle(e:any){
      console.log('data++++++=', e)
      this.setState({ showPopupImage:!this.state.showPopupImage,
        Selecteditemid: e
    })
    }

    render() {
        const {hasError, isLoading, violation} = this.props;
        if (isLoading) {
            return <Loading/>
        }

        if (hasError || !violation) {
            return <BlankSlate/>
        }

        return (
            <Data
                violation={violation}
                imagePopup={this.imagePopupToggle}
                showPopupImage={this.state.showPopupImage}
                PopupImageSource={this.state.Selecteditemid}
            />

        )
    }
});


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryDetails/ViolationsHistoryDetails.tsx